export enum ThemeEnum {
    DARK = 'DARK',
    LIGHT = 'LIGHT',
    SYSTEM = 'SYSTEM'
}
